import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import NavsList from "./NavsList";
import "../Style/submitCart.css";
import { AppContext } from "../App";
import { scrollToTop, showModal } from "./Methods";
export default function SubmitCart() {
  const navigate = useNavigate();
  const [data, setData] = useState({
    addresses: [],
  });
  const [dataLoading, setDataLoading] = useState({
    address: true,
    cart: true,
  });
  const [formData, setFormData] = useState({
    userAddress: null,
    discountCode: null,
  });
  const [discount, setDiscount] = useState({
    value: null,
    code: "",
    msg: "",
  });
  const firstLoad = useRef(true);
  const {
    cartContext: [cartData, setCartData],
    userData: [userInfo],
  } = useContext(AppContext);
  const [price, setPrice] = useState({
    factorPrice: 0,
    deliveryPrice: 0,
    discountPrice: 0,
    discountCodePrice: 0,
    finalPrice: 0,
  });
  useEffect(() => {
    if (firstLoad.current) {
      document.title = "تکمیل سفارش";
      firstLoad.current = false;
      fetchData();
    }
  }, []);
  useEffect(() => {
    calculateCartPrice();
  }, [cartData]);
  function fetchData() {
    const formData = new FormData();
    formData.append("token", userInfo.tkn);
    fetch("https://crm.bamamiresi.com/Enrollment/GetUserAddress", {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("102");
        }
        return res.json();
      })
      .then((json) => {
        if (json.error) {
          throw new Error(json.msg);
        }
        const serverResponse = json;
        scrollToTop();
        setDataLoading({
          ...dataLoading,
          address: false,
        });
        setData({
          ...data,
          addresses: serverResponse,
        });
      })
      .catch((err) => {});
  }
  function changeAddressHandler(addressId) {
    setFormData({ ...formData, userAddress: addressId });
    const deliveryFormData = new FormData();
    deliveryFormData.append("Token", userInfo.tkn);
    deliveryFormData.append("AddressID", addressId);
    fetch("https://crm.bamamiresi.com/Enrollment/GetFreightPriceByAddressID", {
      method: "POST",
      body: deliveryFormData,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("102");
        }
        return res.json();
      })
      .then((json) => {
        if (json.error) {
          throw new Error(json.msg);
        }
        const serverResponse = json[0];
        if (+serverResponse.code === 200) {
          setPrice({ ...price, deliveryPrice: +serverResponse.FreightPrice });
        } else {
          setFormData({ ...formData, userAddress: null });
        }
      })
      .catch(() => {
        setFormData({ ...formData, userAddress: null });
      });
  }
  function submitCodeHandler() {
    if (!discount.code) {
      showModal("لطفا کد تخفیف را وارد کنید.");
      return;
    }
    const deliveryFormData = new FormData();
    deliveryFormData.append("Token", userInfo.tkn);
    deliveryFormData.append("DiscountCode", discount.code);
    fetch("https://crm.bamamiresi.com/Enrollment/GetPriceViaDiscountCode", {
      method: "POST",
      body: deliveryFormData,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("102");
        }
        return res.json();
      })
      .then((json) => {
        const serverResponse = json;
        if (+serverResponse.State === 0) {
          setDiscount({ ...discount, msg: "کد تخفیف نامعبتر است." });
          showModal("کد تخفیف نامعبتر است.");
        } else {
          setDiscount({
            ...discount,
            msg: "",
            value: +serverResponse.Percentage,
          });
          setFormData({ ...formData, discountCode: discount.code });
          showModal("کد تخفیف ثبت شد.");
        }
      })
      .catch((err) => {});
  }
  function removeDicsountHandler() {
    setDiscount({
      value: null,
      code: "",
      msg: "",
    });
    setFormData({ ...formData, discountCode: null });
  }
  function calculateCartPrice() {
    let temptotalDiscount = 0;
    let temptotalPrice = 0;
    cartData.forEach((item) => {
      if (+item.discountPrice > 0) {
        temptotalDiscount +=
          ((+item.price * +item.discountPrice) / 100) * +item.quantity;
      }
      temptotalPrice += +item.price * +item.quantity;
    });
    setPrice({
      ...price,
      discountPrice: temptotalDiscount,
      factorPrice: temptotalPrice,
    });
  }
  function submitCartHanlder() {
    if (formData.userAddress === null) {
      showModal("لطفا ابتدا آدرس را انتخاب کنید.");
      return;
    }
    const deliveryFormData = new FormData();
    deliveryFormData.append("Token", userInfo.tkn);
    deliveryFormData.append("AddressID", formData.userAddress);
    deliveryFormData.append(
      "DiscountCode",
      formData.discountCode ? formData.discountCode : 0
    );
    fetch("https://crm.bamamiresi.com/Enrollment/DoPay", {
      method: "POST",
      body: deliveryFormData,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("102");
        }
        return res.json();
      })
      .then((json) => {
        const serverResponse = json[0];
        if (+serverResponse.code === 200) {
          navigate("/payResult/done");
        }
      })
      .catch((err) => {});
  }
  function getSummaryContent() {
    let tempDiscountPrice = +discount.value
      ? ((+price.factorPrice - price.discountPrice) * +discount.value) / 100
      : 0;
    let finalPrice =
      +price.deliveryPrice +
      +price.factorPrice +
      price.discountPrice -
      tempDiscountPrice;
    return (
      <>
        <div className="flex alignCenter submitCartSummaryItem justifyBetween">
          <p className="faFont submitCartItemText">جمع سبد خرید :</p>
          <p className="faFont submitCartPriceText">
            {(+price.factorPrice).toLocaleString()}
            <span>تومان</span>
          </p>
        </div>
        {+price.discountPrice > 0 && (
          <div className="flex alignCenter submitCartSummaryItem justifyBetween">
            <p className="faFont submitCartItemText">تخفیف :</p>
            <p className="faFont submitCartPriceText">
              {(+price.discountPrice).toLocaleString()}
              <span>تومان</span>
            </p>
          </div>
        )}
        <div className="flex alignCenter submitCartSummaryItem justifyBetween">
          <p className="faFont submitCartItemText">هزینه ارسال :</p>
          <p className="faFont submitCartPriceText">
            {+price.deliveryPrice ? (
              <>
                {(+price.deliveryPrice).toLocaleString()}
                <span>تومان</span>
              </>
            ) : (
              <span>ابتدا آدرس را انتخاب کنید</span>
            )}
          </p>
        </div>
        <div className="flex alignCenter submitCartSummaryItem justifyBetween">
          <p className="faFont submitCartItemText">کد تخفیف :</p>
          <p className="faFont submitCartPriceText">
            {(+tempDiscountPrice).toLocaleString()}
            <span>تومان</span>
          </p>
        </div>
        <div className="flex alignCenter submitCartSummaryItem justifyBetween">
          <p className="faFont submitCartItemText">جمع نهایی :</p>
          <p className="faFont submitCartPriceText">
            {price.deliveryPrice ? (
              <>
                {finalPrice.toLocaleString()}
                <span>تومان</span>
              </>
            ) : (
              <span>ابتدا آدرس را انتخاب کنید</span>
            )}
          </p>
        </div>
        <button
          className={`faFont flex flexCenter submitCartBtn ${
            (!price.factorPrice || !price.deliveryPrice) && "disable"
          }`}
          onClick={() => submitCartHanlder()}
        >
          تایید و پرداخت
        </button>
      </>
    );
  }
  return (
    <>
      {dataLoading.address ? (
        <>
          <section className="cartPageLoadingSection grid container">
            <div className="cartPageDetailsLoading flex flexCol rel">
              <div className="loaderItem"></div>
            </div>
            <div className="cartPageSummaryLoading flex flexCol rel">
              <div className="loaderItem"></div>
            </div>
          </section>
        </>
      ) : (
        <>
          <NavsList
            data={[
              { name: "سبد خرید", link: "/cart" },
              { name: "تکمیل سفارش", link: "/submitCart" },
            ]}
          />
          <section className="grid container submitCartSection">
            <div className="flex flexCol submitCartOptions">
              <div className="flex alignCenter justifyBetween">
                <h2 className="faFont addressesTitle flex alignCenter">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 24 24"
                    height="18"
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill="none"
                      strokeWidth="2"
                      d="M12,22 C12,22 4,16 4,10 C4,5 8,2 12,2 C16,2 20,5 20,10 C20,16 12,22 12,22 Z M12,13 C13.657,13 15,11.657 15,10 C15,8.343 13.657,7 12,7 C10.343,7 9,8.343 9,10 C9,11.657 10.343,13 12,13 L12,13 Z"
                    ></path>
                  </svg>
                  انتخاب آدرس
                </h2>
                <Link
                  className="faFont addAddress flex alignCenter"
                  to={`/profile/addAddress/?ref=submitCart`}
                  draggable="false"
                >
                  <svg
                    stroke="currentColor"
                    fill="none"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    height="16"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M5 12h14"></path>
                    <path d="M12 5v14"></path>
                  </svg>
                  افزودن آدرس
                </Link>
              </div>
              {data.addresses && data.addresses.length > 0 ? (
                <div className="flex flexCol addressesList">
                  {data.addresses.map((item, index) => {
                    return (
                      <label
                        className={`faFont flex alignCenter userAddressLabel ${
                          formData.userAddress === item.id ? "activeLabel" : ""
                        }`}
                        key={index}
                      >
                        <input
                          type="radio"
                          name="address"
                          id={`address-${index}`}
                          onClick={() => changeAddressHandler(item.ID)}
                          autoComplete="off"
                        />
                        {item.Address}
                      </label>
                    );
                  })}
                </div>
              ) : (
                <div className="flex flexCol emptyAddress">
                  <p className="faFont noAddressText">
                    آدرسی ثبت نشده است. بر روی دکمه افزودن آدرس کلیک کنید.
                  </p>
                </div>
              )}

              <div className="flex flexCol discountCodeDiv">
                <h3 className="faFont addressesTitle flex alignCenter">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 256 256"
                    height="18"
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M228.75,100.05c-3.52-3.67-7.15-7.46-8.34-10.33-1.06-2.56-1.14-7.83-1.21-12.47-.15-10-.34-22.44-9.18-31.27s-21.27-9-31.27-9.18c-4.64-.07-9.9-.15-12.47-1.21-2.87-1.19-6.66-4.82-10.33-8.34C148.87,20.46,140.05,12,128,12s-20.87,8.46-27.95,15.25c-3.67,3.52-7.46,7.15-10.33,8.34-2.56,1.06-7.83,1.14-12.47,1.21C67.25,37,54.81,37.14,46,46S37,67.25,36.8,77.25c-.07,4.64-.15,9.91-1.21,12.47-1.19,2.87-4.82,6.66-8.34,10.33C20.46,107.13,12,116,12,128S20.46,148.87,27.25,156c3.52,3.67,7.15,7.46,8.34,10.33,1.06,2.56,1.14,7.83,1.21,12.47.15,10,.34,22.44,9.18,31.27s21.27,9,31.27,9.18c4.64.07,9.9.15,12.47,1.21,2.87,1.19,6.66,4.82,10.33,8.34C107.13,235.54,116,244,128,244s20.87-8.46,27.95-15.25c3.67-3.52,7.46-7.15,10.33-8.34,2.56-1.06,7.83-1.14,12.47-1.21,10-.15,22.44-.34,31.27-9.18s9-21.27,9.18-31.27c.07-4.64.15-9.91,1.21-12.47,1.19-2.87,4.82-6.66,8.34-10.33C235.54,148.87,244,140.05,244,128S235.54,107.13,228.75,100.05Zm-17.32,39.29c-4.82,5-10.28,10.72-13.19,17.76-2.82,6.8-2.93,14.17-3,21.29-.08,5.36-.19,12.71-2.15,14.66s-9.3,2.07-14.66,2.15c-7.13.11-14.49.22-21.29,3-7,2.92-12.73,8.38-17.76,13.2C135.78,214.84,130.4,220,128,220s-7.78-5.16-11.34-8.57c-5-4.82-10.72-10.28-17.76-13.2-6.8-2.81-14.17-2.92-21.29-3-5.36-.08-12.71-.19-14.66-2.15s-2.07-9.3-2.15-14.66c-.11-7.13-.22-14.49-3-21.29-2.91-7-8.37-12.74-13.19-17.76C41.16,135.78,36,130.4,36,128s5.16-7.78,8.57-11.34c4.82-5,10.28-10.72,13.19-17.76,2.82-6.8,2.93-14.17,3-21.29C60.88,72.25,61,64.9,63,63s9.3-2.07,14.66-2.15c7.13-.11,14.49-.22,21.29-3,7-2.92,12.73-8.38,17.76-13.2C120.22,41.16,125.6,36,128,36s7.78,5.16,11.34,8.57c5,4.82,10.72,10.28,17.76,13.2,6.8,2.81,14.17,2.92,21.29,3,5.36.08,12.71.19,14.66,2.15s2.07,9.3,2.15,14.66c.11,7.13.22,14.49,3,21.29,2.91,7,8.37,12.74,13.19,17.76,3.41,3.56,8.57,8.94,8.57,11.34S214.84,135.78,211.43,139.34ZM80,96a16,16,0,1,1,16,16A16,16,0,0,1,80,96Zm96,64a16,16,0,1,1-16-16A16,16,0,0,1,176,160Zm.49-80.49a12,12,0,0,1,0,17l-80,80a12,12,0,0,1-17-17l80-80A12,12,0,0,1,176.49,79.51Z"></path>
                  </svg>
                  کد تخفیف
                </h3>
                {discount.value ? (
                  <div className="flex alignCenter justifyBetween hasDicountDiv">
                    <p className="faFont hasDicountText">
                      مبلغ{" "}
                      {(
                        ((+price.factorPrice - price.discountPrice) *
                          +discount.value) /
                        100
                      ).toLocaleString()}{" "}
                      تومان از هزینه نهایی کم شد.
                    </p>
                    <button
                      className="hasCodeRemoveDiscount flex alignCenter faFont"
                      onClick={() => removeDicsountHandler()}
                    >
                      حذف کد
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="m289.94 256 95-95A24 24 0 0 0 351 127l-95 95-95-95a24 24 0 0 0-34 34l95 95-95 95a24 24 0 1 0 34 34l95-95 95 95a24 24 0 0 0 34-34z"></path>
                      </svg>
                    </button>
                  </div>
                ) : (
                  <div className="flex flexCol insertDiscountDiv">
                    <div className="flex flexCo rel">
                      <input
                        type="text"
                        className="customInput faFont discountInput"
                        id="dicsountCode"
                        placeholder="کد تخفیف را وارد کنید"
                        autoComplete="off"
                        onChange={(e) =>
                          setDiscount({ ...discount, code: e.target.value })
                        }
                        onKeyDown={(e) =>
                          e.key.toLowerCase() === "enter" && submitCodeHandler()
                        }
                      />
                      <button
                        className="submitDiscountCode faFont"
                        onClick={() => submitCodeHandler()}
                      >
                        ثبت
                      </button>
                    </div>
                    {discount.msg !== "" && (
                      <p className="faFont discountWrong">{discount.msg}</p>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="flex flexCol submitSummaryDiv">
              {getSummaryContent()}
            </div>
          </section>
        </>
      )}
    </>
  );
}
